/*
 * <pmax-flavor-notes> — keeps the flavor micro-copy (and, optionally, the main
 * gallery image) in sync with the selected variant option.
 *
 * The notes markup is rendered by the section; each note carries the handle of
 * the option value it belongs to, so no string handleizing happens in JS.
 */
if (!customElements.get('pmax-flavor-notes')) {
  customElements.define(
    'pmax-flavor-notes',
    class PmaxFlavorNotes extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.scope = document.getElementById(`MainProduct-${this.sectionId}`) || document;
        this.notes = Array.from(this.querySelectorAll('.pmax-flavor-note'));

        this.onChange = this.handleChange.bind(this);
        this.scope.addEventListener('change', this.onChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.sectionId && event.data.sectionId !== this.sectionId) return;
            // The picker is re-rendered by the theme, so read the DOM back.
            requestAnimationFrame(() => this.sync());
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.onChange);
        this.variantUnsubscriber?.();
      }

      handleChange(event) {
        if (!event.target.closest('.pmax-flavor-picker')) return;
        this.sync();
      }

      selectedHandle() {
        const checked = this.scope.querySelector('.pmax-flavor-picker input[type="radio"]:checked');
        if (!checked) return null;
        const label = this.scope.querySelector(`label[for="${CSS.escape(checked.id)}"]`);
        return label?.dataset.valueHandle || null;
      }

      sync() {
        const handle = this.selectedHandle();
        if (!handle) return;

        let active = null;
        this.notes.forEach((note) => {
          const match = note.dataset.flavor === handle;
          note.classList.toggle('is-active', match);
          if (match) active = note;
        });

        if (active) this.showMedia(active.dataset.mediaIndex);
      }

      /* Optional override: activate the nth gallery thumbnail for this flavor. */
      showMedia(index) {
        const position = parseInt(index, 10);
        if (!position || position < 1) return;

        const thumbs = this.scope.querySelectorAll('.thumbnail-list__item .thumbnail');
        const thumb = thumbs[position - 1];
        if (!thumb || thumb.getAttribute('aria-current') === 'true') return;
        thumb.click();
      }
    }
  );
}
